module.exports = __webpack_public_path__ + "static/img/4.65e6ff85.png";